import { Component, Input, OnInit, trigger, state, style, transition, animate } from "@angular/core";
import { ConstantService } from "../providers/language.service";
import { LanguageService } from '../providers/lang.service';
import { Http, Response } from '@angular/http';
import { RestApiServices } from '../providers/rest.service';
import { Router, NavigationStart } from '@angular/router';
import { CategoryproductComponent } from '../categoryproduct/categoryproduct.component';
import { CustomStorage } from "../providers/Custom-storage.service";
import { SharedServiceService } from "../shared/shared-service.service";
import {  TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions, ITreeState } from 'angular-tree-component';
import { ITreeNode } from "angular-tree-component/dist/defs/api";
import { LoaderComponent } from '../loader/loader.component';
import { Constant } from '../Constant'
@Component({
  selector: 'panelbaritems',
  templateUrl: './panelitems.component.html',
  styleUrls: ['../app.component.css']

})

export class panelComponent implements OnInit {
  
  nodes: any[];
  showloading: boolean = true;
  category: any;
  showCategories: boolean = true; showSubcategories: boolean = false;
  showSub1categories: boolean = false;
  public active: boolean = false;
  all_dep: string = ""
  public id: number;
  items: any;
  subitems: any;
  sublist1: boolean = true;
  paneldata = [];
  categoryDetails = [];
  selectedItem: any = null;
  name: string;
  portONUList: any;
  public show1: boolean = false;
  public prevClicked: number = -1;
  whenClicked = [false, false];
  order: string = 'description';
  decending = true
  options: ITreeOptions = {
    displayField: 'description',
    hasChildrenField: 'isDepartment == true',
    childrenField: 'subcategory',
    nodeClass: (node) => node.data.description,
    actionMapping: {
      mouse: {
        click: (tree, node, $event) => {
          // console.log(node)
          if (node.hasChildren) {{TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event)
          };
          this.categorySelected(node.data)}
          else{
            this.categorySelected(node.data)
          }
        }
      }
  }
}

  constructor(private http: Http, public router: Router, private restApi: RestApiServices,
    private langService: LanguageService, private localStorage:CustomStorage, 
    private sharedService: SharedServiceService) {
      
  }
//   clicke(){
// console.log('h1')
//   }
  expand(p: any) {
    p.expanded = !p.expanded;

  }
  clicked(index) {
    // console.log(index)
    // only show clicked img info 
    this.selectedItem = this.categoryDetails[index];
    if (this.categoryDetails[this.prevClicked] && this.prevClicked != index) {

      this.categoryDetails[this.prevClicked].show1 = false;
    }
    this.categoryDetails[index].show1 = !this.categoryDetails[index].show1;
    this.prevClicked = index;
  };


  ngOnInit() {
    if(this.categoryDetails.length === 0){
    this.sharedService.getFilterStatus().subscribe(filterStatus => {

    });

    this.sharedService.getCategoriesStatus().subscribe(categoriesStatus => {
      this.headerSelected();
    });

    this.localStorage.getItem(Constant.KEY_FILTERDATA).subscribe(res => {
      
      if(res != null){
        this.showloading = false;
        this.formatCategories(res);
        //this.nodes = res;
      }
    });
    
  //this.paneldata = this.customerService.loadpaneldata();
    //this.languageservice.getData();

    this.restApi.getCategoriesData().subscribe(result => {
      this.showloading = false;
      this.formatCategories(result);
      //this.categoryDetails = result;
    });
  }
}

  isIn = false;   // store state
  toggleState() { // click handler
    let bool = this.isIn;
    this.isIn = bool === false ? true : false;
  }

  formatCategories(data){
    this.categoryDetails = [];
    data.forEach((element, index, array) => {
      if(element.description != ''){
        this.categoryDetails.push(element);
      }
    });

  }

  //Toggle category for Mobile View 
  hideCategoryMobileView($event) {
    this.active = !this.active;
  }

  private toggleText: string = "Show";
  private show: boolean = false;

  public onToggle(): void {
    this.show = !this.show;
    this.toggleText = this.show ? "Hide" : "Show";
  }


  headerSelected() {
    this.showSubcategories = false;
    this.showCategories = true;
  }
  
  categorySelected(category) {
    LoaderComponent.loadingV.next(true);
    this.localStorage.removeItem("paginationData").subscribe(data =>{
      this.sharedService.sethideCategoriesflag(true);
      //this.sharedService.changeFilter(true);
      this.category = category.description;
      this.showSubcategories = true;
      this.showCategories = false;
     this.restApi.changeSelectedCategory(category);
    //  console.log(category)
 this.restApi.getCategoryProducts(category.class_code, "").subscribe(data=>{
   //console.log(data.response.items)
   LoaderComponent.loadingV.next(false);
   if(data.response.items.length>0)
   this.router.navigate(['dashboard/shop', category.class_code, category.description]); 
 })
})
         
  }
}


// WEBPACK FOOTER //
// ./src/app/panelitems/panelitems.component.ts